'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TYPES = ['success', 'warning', 'info', 'error', 'primary', 'secondary', 'light', 'dark', 'count', ''];
var prefixCls = 'a-badge';

//Stateless Component
var Badge = function Badge(_ref) {
  var _ClassNames;

  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'primary' : _ref$type,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      style = _ref.style,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'medium' : _ref$size,
      others = _objectWithoutProperties(_ref, ['type', 'className', 'style', 'children', 'size']);

  var sizeCls = '';
  if (size === 'small') {
    sizeCls = 'sm';
  }

  var classNames = (0, _classnames2.default)(prefixCls, className, (_ClassNames = {}, _defineProperty(_ClassNames, prefixCls + '-' + type, type), _defineProperty(_ClassNames, prefixCls + '-' + sizeCls, sizeCls), _ClassNames));

  return React.createElement(
    'span',
    Object.assign({ className: classNames, style: style }, others),
    children
  );
};

Badge.propTypes = {
  type: _propTypes2.default.oneOf(TYPES),
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  size: _propTypes2.default.oneOf(["small", "medium"])
};

Badge.supportedTypes = TYPES;

exports.default = Badge;